import { Select, SelectItem, SelectTrigger, SelectValue, SelectContent } from '../../components/ui/select';
import { useTranslation } from '../../i18n/hooks';

interface PromptSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

const PromptSelector = ({ value, onChange }: PromptSelectorProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-2 bg-white">
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder={t('promptSelector.select_prompt_template')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="Highlight key features and benefits">{t('promptSelector.highlight_features_benefits')}</SelectItem>
          <SelectItem value="Focus on technical specifications">{t('promptSelector.focus_technical_specs')}</SelectItem>
          <SelectItem value="Emphasize unique selling points<">{t('promptSelector.emphasize_selling_points')}</SelectItem>
          <SelectItem value="custom">{t('promptSelector.custom_prompt')}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default PromptSelector;